"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function PolicyContent() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: intro1Ref,
    isVisible: intro1Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: intro2Ref,
    isVisible: intro2Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: hipaaRef,
    isVisible: hipaaVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: hipaaDescRef,
    isVisible: hipaaDescVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: collectionRef,
    isVisible: collectionVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: collectionDescRef,
    isVisible: collectionDescVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: useRef,
    isVisible: useVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: useDescRef,
    isVisible: useDescVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: sharingRef,
    isVisible: sharingVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: sharingDescRef,
    isVisible: sharingDescVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: securityRef,
    isVisible: securityVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: securityDescRef,
    isVisible: securityDescVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightsRef,
    isVisible: rightsVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightsDescRef,
    isVisible: rightsDescVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: consentRef,
    isVisible: consentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: consentDescRef,
    isVisible: consentDescVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: changesRef,
    isVisible: changesVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: changesDescRef,
    isVisible: changesDescVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: contactRef,
    isVisible: contactVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: contactDescRef,
    isVisible: contactDescVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="policy-content" className="bg-background py-16 lg:py-24">
      <div className="mx-auto max-w-4xl px-6 lg:px-8">
        <div className="space-y-12">
          {}
          <div ref={headerRef} className={`transition-all duration-[var(--duration-medium)] ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <h1 className="font-display font-bold text-4xl lg:text-5xl tracking-tight leading-tight text-foreground">
              Privacy Policy
            </h1>
            <p className="mt-4 text-muted text-base lg:text-lg">
              Effective Date: January 1, 2025
            </p>
          </div>

          <Separator className="bg-border" />

          {}
          <div ref={intro1Ref} className={`transition-all duration-[var(--duration-medium)] ${intro1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <p className="text-foreground text-base lg:text-lg leading-relaxed">
              At ABA With Passion Inc, we are committed to protecting the privacy and confidentiality of all individuals who use our services, visit our website, or interact with our organization. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information in compliance with applicable laws, including the Health Insurance Portability and Accountability Act (HIPAA) and other federal and state privacy regulations.
            </p>
          </div>

          <div ref={intro2Ref} className={`transition-all duration-[var(--duration-medium)] ${intro2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <p className="text-foreground text-base lg:text-lg leading-relaxed">
              By accessing our website or using our services, you acknowledge that you have read, understood, and agree to the terms of this Privacy Policy.
            </p>
          </div>

          <Separator className="bg-border" />

          {}
          <div ref={hipaaRef} className={`transition-all duration-[var(--duration-medium)] ${hipaaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <h2 className="font-display font-bold text-3xl lg:text-4xl tracking-[0.5px] leading-tight text-foreground">
              HIPAA Compliance
            </h2>
          </div>

          <div ref={hipaaDescRef} className={`transition-all duration-[var(--duration-medium)] ${hipaaDescVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <p className="text-foreground text-base lg:text-lg leading-relaxed">
              ABA With Passion Inc is a covered entity under HIPAA. We adhere to strict standards to protect Protected Health Information (PHI) as defined by HIPAA. PHI includes any information that can identify an individual and relates to their past, present, or future health condition, treatment, or payment for healthcare services.
            </p>
            <p className="mt-4 text-foreground text-base lg:text-lg leading-relaxed">
              We implement administrative, physical, and technical safeguards to ensure the confidentiality, integrity, and availability of PHI. Our staff members receive regular training on HIPAA compliance, and we maintain secure systems to protect sensitive data from unauthorized access or disclosure.
            </p>
          </div>

          <Separator className="bg-border" />

          {}
          <div ref={collectionRef} className={`transition-all duration-[var(--duration-medium)] ${collectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <h2 className="font-display font-bold text-3xl lg:text-4xl tracking-[0.5px] leading-tight text-foreground">
              Information We Collect
            </h2>
          </div>

          <div ref={collectionDescRef} className={`transition-all duration-[var(--duration-medium)] ${collectionDescVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <p className="text-foreground text-base lg:text-lg leading-relaxed">
              We may collect the following types of information:
            </p>
            <ul className="mt-4 space-y-2 list-disc list-inside text-foreground text-base lg:text-lg leading-relaxed">
              <li>Personal Information: Name, contact details (email, phone number, address), date of birth, and demographic information.</li>
              <li>Health Information: Clinical assessments, treatment plans, therapy progress notes, behavior data, and any other health-related information necessary for providing ABA services.</li>
              <li>Insurance Information: Details required for billing and claims processing, including insurance provider, policy number, and authorization information.</li>
              <li>Website Data: IP address, browser type, device information, pages visited, and usage patterns collected through cookies and similar technologies.</li>
            </ul>
            <p className="mt-4 text-foreground text-base lg:text-lg leading-relaxed">
              Information is collected directly from you, your authorized representatives, healthcare providers, schools, and insurance companies, as necessary and permitted by law.
            </p>
          </div>

          <Separator className="bg-border" />

          {}
          <div ref={useRef} className={`transition-all duration-[var(--duration-medium)] ${useVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <h2 className="font-display font-bold text-3xl lg:text-4xl tracking-[0.5px] leading-tight text-foreground">
              How We Use Your Information
            </h2>
          </div>

          <div ref={useDescRef} className={`transition-all duration-[var(--duration-medium)] ${useDescVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <p className="text-foreground text-base lg:text-lg leading-relaxed">
              We use the collected information for the following purposes:
            </p>
            <ul className="mt-4 space-y-2 list-disc list-inside text-foreground text-base lg:text-lg leading-relaxed">
              <li>Treatment: To provide, coordinate, and manage ABA therapy services tailored to individual needs.</li>
              <li>Payment: To process billing, submit insurance claims, and manage payments for services rendered.</li>
              <li>Healthcare Operations: To conduct quality improvement activities, staff training, administrative functions, and compliance audits.</li>
              <li>Communication: To respond to inquiries, provide updates about services, and send appointment reminders.</li>
              <li>Legal Compliance: To comply with legal obligations, respond to court orders, and cooperate with regulatory agencies.</li>
            </ul>
            <p className="mt-4 text-foreground text-base lg:text-lg leading-relaxed">
              We do not use or disclose PHI for marketing purposes without your explicit written authorization.
            </p>
          </div>

          <Separator className="bg-border" />

          {}
          <div ref={sharingRef} className={`transition-all duration-[var(--duration-medium)] ${sharingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <h2 className="font-display font-bold text-3xl lg:text-4xl tracking-[0.5px] leading-tight text-foreground">
              Sharing Your Information
            </h2>
          </div>

          <div ref={sharingDescRef} className={`transition-all duration-[var(--duration-medium)] ${sharingDescVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <p className="text-foreground text-base lg:text-lg leading-relaxed">
              We may share your information with third parties only in the following circumstances:
            </p>
            <ul className="mt-4 space-y-2 list-disc list-inside text-foreground text-base lg:text-lg leading-relaxed">
              <li>With Your Consent: We will share information when you provide written authorization or consent.</li>
              <li>Business Associates: We may share PHI with vendors and service providers (e.g., billing companies, IT support) who are bound by HIPAA-compliant agreements to protect your information.</li>
              <li>Healthcare Providers: We may share information with other healthcare professionals involved in your care, such as physicians, therapists, or school personnel, as permitted by law.</li>
              <li>Insurance Companies: To facilitate claims processing and reimbursement.</li>
              <li>Legal Requirements: When required by law, such as in response to a court order, subpoena, or regulatory investigation.</li>
            </ul>
            <p className="mt-4 text-foreground text-base lg:text-lg leading-relaxed">
              We do not sell, rent, or share your personal or health information with third parties for their marketing purposes.
            </p>
          </div>

          <Separator className="bg-border" />

          {}
          <div ref={securityRef} className={`transition-all duration-[var(--duration-medium)] ${securityVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <h2 className="font-display font-bold text-3xl lg:text-4xl tracking-[0.5px] leading-tight text-foreground">
              Data Security
            </h2>
          </div>

          <div ref={securityDescRef} className={`transition-all duration-[var(--duration-medium)] ${securityDescVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <p className="text-foreground text-base lg:text-lg leading-relaxed">
              We employ industry-standard security measures to protect your information, including:
            </p>
            <ul className="mt-4 space-y-2 list-disc list-inside text-foreground text-base lg:text-lg leading-relaxed">
              <li>Encryption of data in transit and at rest.</li>
              <li>Secure access controls and authentication protocols.</li>
              <li>Regular security audits and vulnerability assessments.</li>
              <li>Staff training on data security and privacy best practices.</li>
            </ul>
            <p className="mt-4 text-foreground text-base lg:text-lg leading-relaxed">
              Despite our efforts, no system is completely secure. We encourage you to take precautions when sharing sensitive information online and to contact us immediately if you suspect any unauthorized access to your information.
            </p>
          </div>

          <Separator className="bg-border" />

          {}
          <div ref={rightsRef} className={`transition-all duration-[var(--duration-medium)] ${rightsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <h2 className="font-display font-bold text-3xl lg:text-4xl tracking-[0.5px] leading-tight text-foreground">
              Your Rights
            </h2>
          </div>

          <div ref={rightsDescRef} className={`transition-all duration-[var(--duration-medium)] ${rightsDescVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <p className="text-foreground text-base lg:text-lg leading-relaxed">
              Under HIPAA and other applicable laws, you have the following rights:
            </p>
            <ul className="mt-4 space-y-2 list-disc list-inside text-foreground text-base lg:text-lg leading-relaxed">
              <li>Right to Access: You may request a copy of your health records.</li>
              <li>Right to Amend: You may request corrections to your health information if you believe it is inaccurate or incomplete.</li>
              <li>Right to an Accounting: You may request a list of disclosures we have made of your PHI.</li>
              <li>Right to Restrict: You may request restrictions on certain uses and disclosures of your information.</li>
              <li>Right to Confidential Communication: You may request that we communicate with you in a specific manner or location.</li>
              <li>Right to a Paper Copy: You may request a paper copy of this Privacy Policy at any time.</li>
            </ul>
            <p className="mt-4 text-foreground text-base lg:text-lg leading-relaxed">
              To exercise any of these rights, please contact us using the information provided below.
            </p>
          </div>

          <Separator className="bg-border" />

          {}
          <div ref={consentRef} className={`transition-all duration-[var(--duration-medium)] ${consentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <h2 className="font-display font-bold text-3xl lg:text-4xl tracking-[0.5px] leading-tight text-foreground">
              Consent and Authorization
            </h2>
          </div>

          <div ref={consentDescRef} className={`transition-all duration-[var(--duration-medium)] ${consentDescVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <p className="text-foreground text-base lg:text-lg leading-relaxed">
              By using our services, you consent to the collection, use, and disclosure of your information as described in this Privacy Policy. For certain uses or disclosures of PHI, we may require your written authorization. You have the right to revoke your authorization at any time by submitting a written request.
            </p>
          </div>

          <Separator className="bg-border" />

          {}
          <div ref={changesRef} className={`transition-all duration-[var(--duration-medium)] ${changesVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <h2 className="font-display font-bold text-3xl lg:text-4xl tracking-[0.5px] leading-tight text-foreground">
              Changes to This Privacy Policy
            </h2>
          </div>

          <div ref={changesDescRef} className={`transition-all duration-[var(--duration-medium)] ${changesDescVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <p className="text-foreground text-base lg:text-lg leading-relaxed">
              We reserve the right to update or modify this Privacy Policy at any time. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy periodically to stay informed about how we protect your information.
            </p>
          </div>

          <Separator className="bg-border" />

          {}
          <div ref={contactRef} className={`transition-all duration-[var(--duration-medium)] ${contactVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <h2 className="font-display font-bold text-3xl lg:text-4xl tracking-[0.5px] leading-tight text-foreground">
              Contact Us
            </h2>
          </div>

          <div ref={contactDescRef} className={`transition-all duration-[var(--duration-medium)] ${contactDescVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            <p className="text-foreground text-base lg:text-lg leading-relaxed">
              If you have any questions, concerns, or requests regarding this Privacy Policy or the handling of your information, please contact us:
            </p>
            <div className="mt-6 space-y-3 text-foreground text-base lg:text-lg leading-relaxed">
              <p className="font-semibold">ABA With Passion Inc</p>
              <p>8700 W Flagler St #470
<div>Miami, FL 33174</div></p>
              <p>Phone: (786) 762-2520</p>
              <p>Email: info@abawithpassion.com</p>
            </div>
            <p className="mt-6 text-foreground text-base lg:text-lg leading-relaxed">
              Our Privacy Officer is available to address any concerns and assist you with exercising your rights under this policy.
            </p>
          </div>
        </div>
      </div>
    </section>;
}